import { render, staticRenderFns } from "./FormPass.vue?vue&type=template&id=2f7e9b31&"
import script from "./FormPass.vue?vue&type=script&lang=js&"
export * from "./FormPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports